// extracted by mini-css-extract-plugin
export default {"singleRowCertificate":"AssigneeCard_singleRowCertificate__qw4uX"};